import { createSlice } from "@reduxjs/toolkit"
import { DASH_BOARD } from "../../../constants/reducer_names"

const initialState = {
    dashBoardCallData: [] as any,
    dashBoardChatData: {} as any,
    dashBoardEmailData: [] as any,
    dashBoardSmsData: [] as any,
    dashBoardSocialData:[]as any,
    dashBoardAgentData: {} as any,
    dashboardPerformanceData: {} as any,
    compareDashboardData : []as any,
    compareTrendColumn: []as any,
    compareTrendChartData1 : []as any,
    compareTrendChartData2 : []as any,
    channelDisposition : []as any,
    chatSession : {} as any,
    dashboardAvgData : {} as any,
    channelFilter : {
        channelType: 'All'
    } as any,
    LiveDashFilter: {},
    agentDashFilter: {},
    currentDashTab: '#1',
    dashBoardCallQueue: 0,
    dashBoardVideo: {} as any
}


const dashboardSlice = createSlice({
    name: DASH_BOARD,   
    initialState,
    reducers: {
        callsData: (state, { payload }) => {
            state.dashBoardCallData = payload.dashBoardCallData;
        },
        chatData: (state, { payload }) => {
            state.dashBoardChatData = payload;
        },
        emailData: (state, { payload }) => {
            state.dashBoardEmailData = payload.dashBoardEmailData;
        },
        smsData: (state, { payload }) => {
            state.dashBoardSmsData = payload.dashBoardSmsData;
        },
        socialData: (state, { payload }) => {
            state.dashBoardSocialData = payload.dashBoardSocialData;
        },
        agentData: (state, { payload }) => {
            state.dashBoardAgentData = payload;
        },
        performanceData: (state, { payload }) => {
            state.dashboardPerformanceData = payload;
        },
        compareDashboardData: (state, { payload }) => {
            state.compareDashboardData = payload;
        },
        compareTrendColumn: (state, { payload }) => {
            state.compareTrendColumn = payload;
        },
        compareTrendChartData1: (state, { payload }) => {
            state.compareTrendChartData1 = payload;
        },
        compareTrendChartData2: (state, { payload }) => {
            state.compareTrendChartData2 = payload;
        },
        setchannelDisposition: (state, { payload }) => {
            state.channelDisposition = payload;
        },
        setChatSession: (state, { payload }) => {
            state.chatSession = payload;
        },
        setDashboardAvgData: (state, { payload }) => {
            state.dashboardAvgData = payload;
        },
        setChannelFiter: (state, { payload }) => {
            console.log('payload_---------------',payload)
            state.channelFilter   = payload;
        },
        clearChannelFilter: (state) => {
            state.channelFilter = { channelType: 'All' }
        },
        setLiveDashFilter: (state, { payload }) => {
            state.LiveDashFilter   = payload;
        },
        setAgentDashFilter: (state, { payload }) => {
            state.agentDashFilter   = payload;
        },
        setCurrentDashTab: (state, { payload }) => {
            state.currentDashTab   = payload;
        },
        setDashBoardCallQueue: (state, { payload }) => {
            state.dashBoardCallQueue   = payload;
        },
        videoData: (state, { payload }) => {
            state.dashBoardVideo = payload;
        },
    }
})

export const dashBoardSliceActions = dashboardSlice.actions;
export default dashboardSlice.reducer